import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="image-switcher"
export default class extends Controller {
  static targets = ["image", "map", "button"]

  switch() {
    if (this.imageTarget.classList.contains('d-none')) {
      this.toggleVisibility(this.imageTarget, this.mapTarget, "Karte");
    } else {
      this.toggleVisibility(this.mapTarget, this.imageTarget, "Bild");
    }
  }

  toggleVisibility(targetToShow, targetToHide, buttonText) {
    targetToShow.classList.remove('d-none');
    targetToHide.classList.add('d-none');
    this.buttonTarget.textContent = buttonText;
  }
}
